import {LocalDateTime} from 'js-joda'
import {Decoder, field, nullable, number, object, string} from 'json-bouncer'
import {localDateTimeDecoder} from '../Data/DecodeHelper'

export interface Offer {
    readonly id: number
    readonly inquiryId: number
    readonly addressName1: string
    readonly addressName2: string
    readonly addressName3: string
    readonly addressName4: string
    readonly addressStreet: string
    readonly addressHouseNumber: string
    readonly addressZipCode: string
    readonly addressCity: string
    readonly addressCountry: string
    readonly totalNetPrice: number
    readonly totalGrossPrice: number
    readonly netShippingCosts: number | null
    readonly grossShippingCosts: number | null
    readonly created: LocalDateTime
}

export function offerDecoder(): Decoder<Offer> {
    return object({
        id: field('id', number()),
        inquiryId: field('inquiryId', number()),
        addressName1: field('addressName1', string()),
        addressName2: field('addressName2', string()),
        addressName3: field('addressName3', string()),
        addressName4: field('addressName4', string()),
        addressStreet: field('addressStreet', string()),
        addressHouseNumber: field('addressHouseNumber', string()),
        addressZipCode: field('addressZipCode', string()),
        addressCity: field('addressCity', string()),
        addressCountry: field('addressCountry', string()),
        totalNetPrice: field('totalNetPrice', number()),
        totalGrossPrice: field('totalGrossPrice', number()),
        netShippingCosts: field('netShippingCosts', nullable(number())),
        grossShippingCosts: field('grossShippingCosts', nullable(number())),
        created: field('created', localDateTimeDecoder()),
    })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/Offer.ts